import { render } from "./LeaveAdminArticleDetailView.vue?vue&type=template&id=11d69380&scoped=true"
import script from "./LeaveAdminArticleDetailView.vue?vue&type=script&lang=js"
export * from "./LeaveAdminArticleDetailView.vue?vue&type=script&lang=js"

import "./LeaveAdminArticleDetailView.vue?vue&type=style&index=0&id=11d69380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d69380"]])

export default __exports__